import classes from './TimeBar.module.scss'
import useVideo from "../../hooks/useVideo"
import { getFilteredSlicePoints } from '../../utils/functions';
import TimeBarProgress from './TimeBarProgress';
import PlayIcon from '../../icons/Play';
import PauseIcon from '../../icons/Pause';
import TimeBarPoint from './TimeBarPoint';
import useVideoQuizConfig from '../../hooks/useVideoQuizConfig';
import { GAMEMODE } from '../../utils/constants';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { goToQuestion } from '@educaplay/store/slices/gameSlice';
import { NAME_SOUND_HOVER, useGameSounds } from '@educaplay/core';

const QUESTION_TYPE_VARIANT = {
    information: "info",
}
export function TimeBar(props) {
    const { questions, totalDuration, currentQuestion, onClick } = props;
    const { playing, progress, ref } = useVideo();
    const { gameMode } = useVideoQuizConfig();
    const IconButton = playing ? PauseIcon : PlayIcon;
    const dispatch = useDispatch();
    const gameSound = useGameSounds();  

    const slicePoints = questions.map(question => {
        const questionTimeAppear = question.timeAppearWithDuration !== null ? question.timeAppearWithDuration : question.timeAppear;
        return {
            id: question.id,
            variant: QUESTION_TYPE_VARIANT[question.questionType] ?? "default",
            done: question.answer && question.answer.answer !== null,
            pending: question.answer !== null && question.answer.answer === null,
            incorrect: question.answer?.answer !== null && question.checkAnswer(question.answer) === false,
            active: progress === questionTimeAppear && currentQuestion.id === question.id,
            left: (questionTimeAppear / totalDuration) * 100,
            timeAppear: questionTimeAppear,
        }
    });
    const slicePointsFiltered = getFilteredSlicePoints(slicePoints);

    return (
        <div className={classes.barContainer}>
            <div className={classes.progressBar}>
                <button type='button' className={classes.playPauseButton} onClick={onClick} onMouseEnter={()=> gameSound.play(NAME_SOUND_HOVER)}>
                    <IconButton />
                </button>

                <div className={clsx(classes.progressBarInner, GAMEMODE.SEQUENTIAL === gameMode && classes.disabled)}>
                    <TimeBarProgress
                        totalDuration={totalDuration}
                        questions={questions}
                    />

                    <div className={classes.slicepointsContainer}>
                        {slicePointsFiltered.map((slicePoint) => (
                            <TimeBarPoint
                                key={slicePoint.id}
                                variant={slicePoint.variant}
                                done={slicePoint.done}
                                active={slicePoint.active}
                                left={slicePoint.left}
                                incorrect={slicePoint.incorrect}
                                pending={slicePoint.pending}
                                onClick={() => {
                                    if (gameMode === GAMEMODE.FREEDOM) {
                                        ref.current.seekTo(slicePoint.timeAppear)
                                        setTimeout(() => {
                                            dispatch(goToQuestion(questions.findIndex(q => q.id === slicePoint.id)))
                                        });
                                    }
                                }}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

